export const SHOW_NEW_FOCUS_AREA_VIEW_SINCE_THIS_YEAR = 2024
